import type { Weekday } from '../Models/enums';
import type { TranslationKey } from './he';

/**
 * Weekday 0 is Sunday, matching Date.getDay and the stored column, so a
 * weekday can index this array directly rather than being mapped by hand at
 * each call site.
 */
export const WEEKDAY_KEYS: Readonly<Record<Weekday, TranslationKey>> = [
  'weekdaySunday',
  'weekdayMonday',
  'weekdayTuesday',
  'weekdayWednesday',
  'weekdayThursday',
  'weekdayFriday',
  'weekdaySaturday'
] as const;
